import { style } from '@vanilla-extract/css'

import { getFontSize } from '~/styles/mixins/font.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const homeRightColumn = style({
  padding: '80px 0',
  backgroundColor: cssVariables.color.concrete.hex,
})

export const homeRightColumn_inner = style({
  '@media': {
    [getMediaQuery('md')]: {
      selectors: {
        '&:not(:root)': {
          paddingLeft: 40,
          marginLeft: 0,
          maxWidth: `calc((${cssVariables.layout.inner.width.large} / 2) + (${cssVariables.layout.inner.padding.md} * 2))`,
        },
      },
    },
  },
})

export const homeCommit = style({})

export const homeCommit_container = style({})

export const homeCommit_events = style({})

export const homeCommit_contentsTitle = style({
  marginTop: 40,
})

export const homeCommit_profileList = style({
  marginTop: 24,
})

export const homeCommit_thumbnailList = style({
  marginTop: 40,
})

export const homeScalers = style({
  marginTop: 80,
})

export const homeScalers_container = style({})

export const homeScalers_events = style({})

export const homeScalers_contentsTitle = style({
  marginTop: 40,
})

export const homeScalers_thumbnailList = style({
  marginTop: 16,
})

export const homeScalers_note = style({
  marginTop: 16,
  fontSize: getFontSize(12),
  paddingLeft: '1em',
  textIndent: '-1em',
})

export const homeValue = style({
  marginTop: 32,
})

export const homeValue_container = style({})

export const homeValueTitle = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 24px',

  selectors: {
    '&:after': {
      content: '',
      position: 'absolute',
      zIndex: 1,
      bottom: 0,
      left: 0,
      display: 'block',
      width: '100%',
      height: '50%',
      backgroundColor: cssVariables.color.white.hex,
      borderRadius: '12px 12px 0 0',
      border: `2px solid ${cssVariables.color.silver.hex}`,
      borderBottom: 'none',
    },
  },
})

export const homeValueTitle_container = style({
  position: 'relative',
  zIndex: 2,
  backgroundColor: cssVariables.color.alto.hex,
  padding: '12px 32px',
})

export const homeValueTitle_text = style({
  fontWeight: cssVariables.font.weight.bold,
  fontSize: getFontSize(14),
  textAlign: 'center',
})

export const homeValue_contents = style({
  backgroundColor: cssVariables.color.white.hex,
  borderRadius: '0 0 12px 12px',
  border: `2px solid ${cssVariables.color.silver.hex}`,
  borderTop: 'none',
  padding: 16,
})

export const homeValueList__col4 = style({})

export const homeValueList__col5 = style({})

export const homeValueList = style({})

export const homeValueList_items = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  columnGap: 16,
  rowGap: 16,

  '@media': {
    [getMediaQuery('sm')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },

    [getMediaQuery('lg')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },

  selectors: {
    [`${homeValueList}${homeValueList__col5} &`]: {
      '@media': {
        [getMediaQuery('lg')]: {
          gridTemplateColumns: 'repeat(5, 1fr)',
        },
      },
    },
  },
})

export const homeValueList_item = style({})

export const homeValueList_contents = style({})

export const homeValueListThumbnail = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: '1 / 1',
  width: '100%',
  height: 'auto',
  margin: '0 auto',
  maxWidth: 96,
})

export const homeValueListThumbnail_image = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
})

export const homeValueList_title = style({
  fontWeight: cssVariables.font.weight.bold,
  fontSize: getFontSize(14),
  textAlign: 'center',
  marginTop: 12,
})
